var interval = document.getElementById("page-main-content").getAttribute("data-refresh-interval");

window.addEventListener('load', () => {
    if (interval) {
        setTimeout(function () {
            window.location.reload();
        }, interval);
    }
});
